import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [!_vm.isAnyFocused && !_vm.isAnyActionInProgress ? _c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle mt-1",
    on: {
      click: _vm.close
    }
  })], 1) : _vm._e(), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Edit required tasting photo")])]), _c("div", {
    staticClass: "content-centered large text-left"
  }, [_vm.isEditing && !_vm.isLoading && _vm.dbSyncedValues ? _c("div", {
    staticClass: "text-smaller"
  }, [_c("div", [_c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("Reference :")]), _vm._v(" " + _vm._s(_vm.dbSyncedValues.fromReference) + " ")]), _c("div", [_c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("User")]), _vm._v(" : " + _vm._s(_vm.dbSyncedValues.user.fullName) + " ")]), _c("div", [_c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("Wine")]), _vm._v(" : " + _vm._s(_vm.dbSyncedValues.wine.displayName + " - " + _vm.dbSyncedValues.wine.namingData.sku) + " ")]), _c("div", [_c("span", {
    staticClass: "text-smaller"
  }, [_vm._v("Initial number of bottles")]), _vm._v(" : " + _vm._s(_vm.dbSyncedValues.nbBottlesInit) + " ")])]) : _vm._e(), _c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c("div", {
    staticClass: "grid cols-x2 xs--cols-x1"
  }, [_c(VTextField, {
    attrs: {
      disabled: _vm.isLoading,
      readonly: _vm.isUpdatingNbBottlesRemaining,
      label: "Nb bottles remaining",
      "hide-details": "auto",
      type: "number",
      min: 0
    },
    on: {
      focus: function focus($event) {
        _vm.isNbBottlesRemainingFocused = true;
      },
      blur: function blur($event) {
        _vm.isNbBottlesRemainingFocused = false;
        _vm.checkChangeNbBottlesRemaining();
      },
      keypress: _vm.filterIntegerKey
    },
    model: {
      value: _vm.form.nbBottlesRemaining,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nbBottlesRemaining", $$v);
      },
      expression: "form.nbBottlesRemaining"
    }
  })], 1)])], 1)], 1)], 1), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };